import CryptoJS from "crypto-js";

// ----------------------------
// AES Encrypt
// ----------------------------
export function encryptData(text) {
    const KEY = "INMATEINBOX987654321"; // 32 chars → AES-256
    const IV = "1234567890980563"; // 16 chars → IV

    const key = CryptoJS.enc.Utf8.parse(KEY);
    const iv = CryptoJS.enc.Utf8.parse(IV);

    const encrypted = CryptoJS.AES.encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString(); // Base64 format
}

// ----------------------------
// AES Decrypt (with safe fallback)
// ----------------------------
export function decryptData(cipherText) {
    const KEY = "INMATEINBOX987654321";
    const IV = "1234567890980563";

    try {
        if (!cipherText || cipherText.trim() === "") return null;

        const key = CryptoJS.enc.Utf8.parse(KEY);
        const iv = CryptoJS.enc.Utf8.parse(IV);

        const bytes = CryptoJS.AES.decrypt(cipherText, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        // if empty (invalid ciphertext), return null
        return decrypted && decrypted.trim() !== "" ? decrypted : null;

    } catch (err) {
        console.error("Decrypt error:", err);
        return null;
    }
}




// ----------------------------
// Auto get: admin -> sessionStorage, else -> localStorage
// ----------------------------
export const getStoredValue = (key) => {
    try {
        const isFromAdmin = !!sessionStorage.getItem("from");
        const source = isFromAdmin ? sessionStorage : localStorage;

        const encrypted = source.getItem(key);
        if (!encrypted) return null;

        const decrypted = decryptData(encrypted);
        if (!decrypted) return null;

        try {
            return JSON.parse(decrypted);
        } catch (err) {
            console.warn(`Invalid JSON for key "${key}"`);
            return null;
        }
    } catch (error) {
        console.error(`Error reading stored value "${key}"`, error);
        return null;
    }
};


// ----------------------------
// Local only get
// ----------------------------
export const getLocalStoredValue = (key) => {
    try {
        const encrypted = localStorage.getItem(key);
        if (!encrypted) return null;

        const decrypted = decryptData(encrypted);
        if (!decrypted) return null;

        return JSON.parse(decrypted);
    } catch (error) {
        console.error(`Error reading local stored value "${key}"`, error);
        return null;
    }
};


// ----------------------------
// Session only get
// ----------------------------
export const getSessionStoredValue = (key) => {
    try {
        const encrypted = sessionStorage.getItem(key);
        if (!encrypted) return null;

        const decrypted = decryptData(encrypted);
        if (!decrypted) return null;

        return JSON.parse(decrypted);
    } catch (error) {
        console.error(`Error reading session stored value "${key}"`, error);
        return null;
    }
};


// ----------------------------
// Auto set value (encrypt)
// ----------------------------
export const setStoredValue = (key, value) => {
    try {
        const isFromAdmin = !!sessionStorage.getItem("from");
        const target = isFromAdmin ? sessionStorage : localStorage;

        const encrypted = encryptData(JSON.stringify(value));
        target.setItem(key, encrypted);
    } catch (error) {
        console.error(`Error setting stored value "${key}"`, error);
    }
};


// ----------------------------
// Local only set (encrypt)
// ----------------------------
export const setLocalStoredValue = (key, value) => {
    try {
        const encrypted = encryptData(JSON.stringify(value));
        localStorage.setItem(key, encrypted);
    } catch (error) {
        console.error(`Error setting local stored value "${key}"`, error);
    }
};


// ----------------------------
// Session only set (encrypt)
// ----------------------------
export const setSessionStoredValue = (key, value) => {
    try {
        const encrypted = encryptData(JSON.stringify(value));
        sessionStorage.setItem(key, encrypted);
    } catch (error) {
        console.error(`Error setting session stored value "${key}"`, error);
    }
};


// ----------------------------
// Remove key from both storages
// ----------------------------
export const removeStoredValue = (key) => {
    try {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    } catch (error) {
        console.error(`Error removing value "${key}"`, error);
    }
};

